<template>
  <q-page class="main">
    <common-form :action="$route('rule.update', {richtlijn: rule.id})" is-update>
      <q-card class="page-card">
        <q-card-section class="page-card__main-content">
          <rule-form :rule="rule"
                     :rule-version="ruleVersion"
                     :themes="themes"
                     :phases="phases"
                     :categories="categories"
                     :subcategories="subcategories"
                     :editableCategories="editableCategories"
          />
          <div v-if="!$isDesktop" class="row justify-end q-pt-lg">
            <accent-button label="Opslaan" type="submit" />
          </div>
        </q-card-section>
        <q-separator />
        <q-card-actions align="right" class="q-pa-md">
          <accent-button label="Opslaan" type="submit" />
        </q-card-actions>
      </q-card>
      <sticky-top-bar />
    </common-form>
  </q-page>
</template>

<script>
import RuleForm from "./RuleForm"
import ChipList from "~HIOR/components/lists/ChipList"
import DocumentList from "~HIOR/components/lists/DocumentList"

export default {
  components: {
    ChipList,
    DocumentList,
    RuleForm,
  },
  props: {
    rule: {
      type: Object,
      default: null,
    },
    ruleVersion: {
      type: Object,
      default: null,
    },
    phases: {
      type: Object,
      default: null,
    },
    categories: {
      type: Object,
      default: null,
    },
    editableCategories: {
      type: Object,
      default: null,
    },
    subcategories: {
      type: Object,
      default: null,
    },
    themes: {
      type: Array,
      default: null,
    },
  },
}
</script>
